import { api } from './api';

export type AppNotification = {
  id: string;
  type: string;
  priority: string;
  channel: string;
  status: string;
  subject: string;
  message: string;
  data: Record<string, unknown>;
  reference_type: string | null;
  reference_id: string | null;
  read_at: string | null;
  created_at: string | null;
};

type NotificationPage = {
  items: AppNotification[];
  total: number;
};

export const notificationsService = {
  async list(params?: {
    unread_only?: boolean;
    size?: number;
    page?: number;
  }): Promise<NotificationPage> {
    const r = await api.get<NotificationPage>('/notifications', { params });
    return r.data;
  },

  async unreadCount(): Promise<number> {
    const r = await api.get<{ unread_count: number }>(
      '/notifications/unread-count'
    );
    return r.data.unread_count;
  },

  async markRead(id: string): Promise<void> {
    await api.post(`/notifications/${id}/read`);
  },

  async markAllRead(): Promise<void> {
    await api.post('/notifications/read-all');
  },
};
